import {API_URL} from "../config";

export const REGISTER_URL = `${API_URL}/users/newuser`;
